import { Forms } from "../../components/backgrounds/Forms";
import { Steps } from "../../components/buttons/Steps";
import { Primary } from "../../components/buttons/Primary";
// import TagManager from "../../components/googleTag/TagManager";
import { useEffect, useState } from "react";
import { GET_SETTING_BY_NAME } from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { FloatFooter } from "../../components/navigation/FloatFooter";

const apiClient = new APIClient();
const settingName = "redirect-denied";
const urlCrezu = "https://track.leadbazaar.co/click?pid=6180&offer_id=389";

export function CrezuPage() {
  const [url, setUrl] = useState(urlCrezu);
  const [isLoading, setIsLoading] = useState(false);

  const loadSetting = async () => {
    try {
      let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
        name: settingName,
      });
      let value = data?.data?.value;
      return value;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    //Get configs from backend
    setIsLoading(true);
    loadSetting()
      .then((value) => {
        if (Array.isArray(value) && value.length > 0) {
          let redirectDenied = value.find((item) => item.active === true);
          if (redirectDenied) {
            console.log(
              `La url de redireccion es: ${redirectDenied?.url} del parter: ${redirectDenied?.name}`
            );
            setUrl(redirectDenied.url);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <div>Viajando...</div>;

  return (
    <div className="bg-purpleLight h-full min-h-screen mb-4">
      {/* <TagManager /> */}
      <Steps
        estado1="complete"
        estado2="complete"
        estado3="current"
        estado4="upcoming"
      />
      <Forms
        title="Tenemos una oferta de crédito distinta para ti"
        description={"¡Felicidades! Tienes pre-aprobado un cupo por $1.500.000"}
        form={
          <div className="shadow-lg overflow-hidden rounded-md">
            <div className="px-4 py-5 bg-white sm:p-6">
              <div className="lg:px:4 pb-10">
                <span>
                  En estos momentos no podemos atender tu solicitud en Galilea,
                  sin embargo, uno de nuestros aliados te ha pre-aprobado un
                  cupo por valor de $1.500.000. Puedes ingresar ahora mismo a su
                  web para continuar con el desembolso, estaremos atentos a la
                  evolución de tu solicitud, gracias por confiar en nosotros.
                </span>
              </div>

              <div className="py-10 grid justify-items-center ">
                <img
                  className="w-60 h-auto"
                  src="/png/crezu.png"
                  alt="crezu-galilea"
                />
              </div>
            </div>
            <div className="px-4 py-6 flex justify-end bg-white text-right sm:px-6">
              <a href={url} className="w-56 md:w-56" data-aliado="crezu">
                <Primary text="Continuar solicitud" />
              </a>
            </div>
          </div>
        }
      />
      <FloatFooter />
    </div>
  );
}
